import { CrudStore } from 'core/types/crudStore'

export async function getTopPartnerId(partnerId: string = '') {
  const source = partnerId.indexOf('new-') === -1 ? 'PartnerAllData' : 'NewPartners'
  const crud = CrudStore.get(source, `acknowledgment-top-partner-id:${partnerId}`)

  const topPartnerId = await crud
    .getById({ id: partnerId, keyField: 'PartnerID' })
    .then(({ TopPartnerID }) => TopPartnerID)
    .catch(() => partnerId)

  return topPartnerId || partnerId
}
